/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Status_MatchedInputs */

const vi_reconcile_status_matched = /** @type {(inputs: Reconcile_Status_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã khớp`)
};

/**

* @param {Reconcile_Status_MatchedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_status_matched = /** @type {((inputs?: Reconcile_Status_MatchedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Status_MatchedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_status_matched(inputs)
});